import { gql, useQuery } from "@apollo/client";
import { getLessonsListBackOffice } from "../__generated__/gql-types/getLessonsListBackOffice";

const GET_LESSONS_LIST_BACKOFFICE = gql`
  query getLessonsListBackOffice {
    getLessonsListBackOffice {
      id
      title
      deleted_at
      course_id
      grade {
        name
        id
      }
      lesson_type
    }
  }
`;

const useGetLessonsListBackOffice = () => {
  return useQuery<getLessonsListBackOffice>(GET_LESSONS_LIST_BACKOFFICE, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first'
  });
};

export default useGetLessonsListBackOffice;
